import type { ReactNode } from 'react';
import FieldOverrideIndicator from '../../common/FieldOverrideIndicator.interstate';
import type { PaymentGridOverrideField } from '../hooks/usePaymentGridOverrideIndicator';

const TEST_ID_SEGMENT: Record<PaymentGridOverrideField, string> = {
    sellRate: 'sell-rate',
    residual: 'residual'
};

export const paymentGridOverrideIndicatorTestId = (field: PaymentGridOverrideField, index: number): string =>
    `grid-${TEST_ID_SEGMENT[field]}-override-indicator-${index}`;

type PaymentGridOverrideIndicatorProps = {
    field: PaymentGridOverrideField;
    index: number;
    enabled: boolean;
    show: boolean;
    message: string;
    children: ReactNode;
};

export const PaymentGridOverrideIndicator = ({
    field,
    index,
    enabled,
    show,
    message,
    children
}: PaymentGridOverrideIndicatorProps) => (
    <FieldOverrideIndicator
        enabled={enabled}
        show={show}
        message={show ? message : ''}
        testId={paymentGridOverrideIndicatorTestId(field, index)}
        reserveSpace={false}
        overlayIcon
    >
        {children}
    </FieldOverrideIndicator>
);
